var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.transitionName,"mode":_vm.transitionMode,"enter-active-class":_vm.transitionEnterActiveClass,"leave-active-class":_vm.transitionLeaveActiveClass},on:{"beforeLeave":_vm.beforeLeave,"enter":_vm.enter,"afterEnter":_vm.afterEnter}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }